<template>
  <el-button class="d-login-btn" :type="type" size="medium" :disabled="isDisable" @click="handleClick">{{this.buttonTitle}}</el-button>
</template>
<script>
export default {
  name: 'commonbutton',
  props: {
    buttonTitle: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('buttonClick')
    }
  },
}
</script>